import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCampaign } from "../repositories/MillSetupRepository";

interface UseUpdateCampaignOptions {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
}

export const useUpdateCampaign = ({
	onSuccess,
	onError,
}: UseUpdateCampaignOptions = {}) => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: updateCampaign,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["millSetup", "campaign"] });
			onSuccess?.();
		},
		onError: (error: Error) => {
			onError?.(error);
		},
	});

	return {
		updateCampaign: mutation.mutate,
		isUpdating: mutation.isPending,
	};
};
